var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHackernews = function SvgHackernews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 50 50",
    style: {
      fill: "currentColor"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4v42h42V4H4zm2 2h38v38H6V6zm6.652 7 1.586 2.947L21 28.504V38h8v-9.496l6.762-12.557L37.348 13h-7.684l-.576 1.008L25 21.158l-4.088-7.15L20.338 13h-7.686zM16 15h3.176L25 25.188 30.824 15H34l-7 13v8h-4v-8l-7-13z"
  })));
};
export default SvgHackernews;